var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerPrivateAvailable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 41.847,
    viewBox: "0 0 34 41.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2fffd1;}.b,.c{fill:#fff;}.c{fill-rule:evenodd;}.d{fill:#2fff66;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-294 -399.284)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(294 399.284)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-108-54.207A15.9,15.9,0,0,0-124-70a15.9,15.9,0,0,0-16,15.793c0,10.265,16,26.055,16,26.055s16-15.79,16-26.055",
    transform: "translate(140 70)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.774 4.145)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M903.348,255.814v.032a2.313,2.313,0,0,0,.743,1.671,6.935,6.935,0,0,1,2.09,5.059v.08c0,3.625-2.47,6.653-6.374,6.653a6.484,6.484,0,0,1-6.414-6.733v-.08a6.869,6.869,0,0,1,2.087-5.092,2.255,2.255,0,0,0,.745-1.649h0a2.2,2.2,0,0,0-3.586-1.708,10.888,10.888,0,0,0-4.066,8.529v.08a10.879,10.879,0,0,0,11.155,10.876A11,11,0,0,0,911,262.576v-.08a10.774,10.774,0,0,0-3.99-8.44A2.252,2.252,0,0,0,903.348,255.814Z",
    transform: "translate(-888.573 -252.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1016.17,237.555a2.046,2.046,0,1,1,2.046,2.046,2.046,2.046,0,0,1-2.046-2.046",
    transform: "translate(-1007.01 -235.509)"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(318 401)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerPrivateAvailable);
export default __webpack_public_path__ + "static/media/marker_private_available.2b5bf5d76e7b81508343f67004f74858.svg";
export { ForwardRef as ReactComponent };